<template>
  <DialogTemplate>
    <div
      class="pt-2 mr-4 pl-2"
      style="max-width: 460px"
    >
      <div class="text-large weight_700 clr-primary">
        {{ $t('tips.study.filter.range_length_title') }}
      </div>
      <div
        v-for="item in opts"
        :key="item.title"
      >
        <div class="f-align-center pb-1 weight_700 mt-4">
          <div
            class="rlmn_icon"
            :class="item.icon_class"
          ></div>
          {{ item.title }}
        </div>
        <div class="ml-8">
          <div>{{ item.explanation }}</div>
        </div>
      </div>
    </div>

    <template #dialog_actions>
      <v-btn
        class="ml-auto"
        @click="close"
      >
        {{ $t('btn.close') }}
      </v-btn>
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'

export default {
  name: 'RangeLengthHelpDialog',
  components: {
    DialogTemplate,
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$store.dispatch('router_reset_dialogs')
    },
  },
  computed: {
    opts() {
      return [
        {
          icon_class: 'icon_full_length',
          title: this.$t('tips.study.filter.full_length'),
          explanation: this.$t('tips.study.filter.full_length_explanation'),
        },
        {
          icon_class: 'icon_range_length',
          title: this.$t('tips.study.filter.range_length'),
          explanation: this.$t('tips.study.filter.range_length_explanation'),
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.icon_range_length {
  &:before {
    width: 50%;
    bottom: 0;
  }
}
.icon_full_length {
  &:before {
    width: 100%;
  }
}
.rlmn {
  // display: flex;
  // height: var(--switcher-height);
  // overflow: hidden;
  // border-radius: 4px;
  &_icon {
    height: 16px;
    width: 16px;
    margin: 0 12px 0 3px;

    border-radius: 2px;
    border: solid currentColor 1px;
    overflow: hidden;
    position: relative;
    &:before {
      content: '';
      background: currentColor;
      height: 100%;
      position: absolute;
    }
  }
}
</style>
